// tiny utils
const safeTrim = v => (typeof v === 'string' ? v.trim() : v);
const toNumberOrNull = v => (v == null || v === '' ? null : Number(v));
const isArrayNotEmpty = arr => Array.isArray(arr) && arr.length > 0;

const getFlightHeaderMeta = (header, n) => {
  const p = `Option${n}_Flight_`;
  return {
    travelAgency: safeTrim(header[`${p}TravelAgency`]),
    travelAgencyDescription: safeTrim(header[`${p}TravelAgency_Description`]),
    currency: safeTrim(header[`${p}Curr`]),
    quoteValue: toNumberOrNull(header[`${p}QuoteValue`]),
    refund: toNumberOrNull(header[`${p}Refund`]),
    rebooking: safeTrim(header[`${p}Rebooking`]), // 'Yes'/'No' in your data
    terms: safeTrim(header[`${p}Terms`]),
  };
};

const getHotelHeaderMeta = (header, n) => {
  const p = `Option${n}_Hotel_`;
  return {
    currency: safeTrim(header[`${p}Curr`]),
    ratesPerNight: toNumberOrNull(header[`${p}RatesPerNight`]),
    quoteValue: toNumberOrNull(header[`${p}QuoteValue`]),
    terms: safeTrim(header[`${p}Terms`]),
    travelAgency: safeTrim(header[`${p}Travel_Agency`]), // note the underscore in your payload
  };
};

export const getSelectedFlight = data => {
  const n = Number(data?.headerDetails?.Selected_Option_Flight || 0);
  if (!n) return null;

  const option =
    isArrayNotEmpty(data?.flightOptions) &&
    data.flightOptions.find(o => Number(o.optionNo) === n);

  if (!option) return null;

  return {
    selectedOptionNo: n,
    headerMeta: getFlightHeaderMeta(data.headerDetails, n),
    option, // { optionNo, segments: [...] }
  };
};

export const getSelectedHotel = data => {
  const n = Number(data?.headerDetails?.Selected_Option_Hotel || 0);
  if (!n) return null;

  const option =
    isArrayNotEmpty(data?.hotelOptions) &&
    data.hotelOptions.find(o => Number(o.optionNo) === n);

  if (!option) return null;

  return {
    selectedOptionNo: n,
    headerMeta: getHotelHeaderMeta(data.headerDetails, n),
    option, // { optionNo, segments: [...] }
  };
};

// Coerce anything to a finite number; strip currency, commas, spaces
export const toNum = v => {
  if (v == null) return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  const s = String(v)
    .replace(/[^0-9.,-]+/g, '')
    .replace(/,/g, '')
    .trim(); // keep digits, dot, minus
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

export const sum = arr => arr.reduce((acc, v) => acc + toNum(v), 0);

export const format2 = n =>
  toNum(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
